import { render } from "./feature-list.vue?vue&type=template&id=7178a1c0"
import script from "./feature-list.vue?vue&type=script&lang=js"
export * from "./feature-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__